import React, { useState, useRef, useEffect } from "react";
import { Handle, Position } from "@xyflow/react";

export const RowNode = ({ data, id, selected = false }) => {
  console.log("=== ROW NODE RENDER ===", { id, data, selected });
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  // Check if this handle is connected
  const isHandleConnected = (handleId) => {
    if (!data.edges || !Array.isArray(data.edges)) {
      return false;
    }
    return data.edges.some((edge) => edge.sourceHandle === handleId);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };

    if (showMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  const handleDelete = () => {
    if (data.onDeleteRow) {
      data.onDeleteRow(id);
    }
    setShowMenu(false);
  };

  const isConnected = isHandleConnected(id + "-output");

  const menuStyle = {
    position: "absolute",
    top: 30,
    right: 8,
    background: "white",
    border: "1px solid #ddd",
    borderRadius: "4px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
    zIndex: 2,
    minWidth: "100px",
  };

  const menuItemStyle = {
    padding: "6px 10px",
    cursor: "pointer",
    fontSize: "11px",
    borderBottom: "1px solid #eee",
    transition: "background-color 0.2s",
  };

  return (
    <div
      style={{
        background: selected ? "#f8f9fa" : "#ffffff",
        border: `1px solid ${selected ? "#1976d2" : "#e0e0e0"}`,
        borderRadius: "4px",
        padding: "6px",
        width: "140px",
        minHeight: "40px",
        boxShadow: selected
          ? "0 2px 4px rgba(25, 118, 210, 0.2)"
          : "0 1px 2px rgba(0,0,0,0.1)",
        position: "relative",
        fontSize: "10px",
      }}
    >
      {/* Menu Icon */}
      <div
        style={{
          position: "absolute",
          top: 4,
          right: 4,
          cursor: "pointer",
          fontSize: 12,
          color: selected ? "#1976d2" : "#6c757d",
          zIndex: 1,
          userSelect: "none",
          fontWeight: "bold",
          lineHeight: "1",
        }}
        onClick={() => setShowMenu(!showMenu)}
        title="Menu"
      >
        ⋮
      </div>

      {showMenu && (
        <div ref={menuRef} style={menuStyle}>
          <div
            style={{ ...menuItemStyle, borderBottom: "none" }}
            onClick={handleDelete}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#f5f5f5")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "white")
            }
          >
            🗑️ Delete Row
          </div>
        </div>
      )}

      {/* Left Handle (Input) */}
      <Handle
        type="target"
        position={Position.Left}
        style={{
          background: selected ? "#1976d2" : "#6c757d",
          width: "6px",
          height: "6px",
        }}
      />

      {/* Row Content */}
      <div style={{ textAlign: "left", paddingRight: "20px" }}>
        <div
          style={{
            fontWeight: "bold",
            color: selected ? "#1976d2" : "#495057",
            marginBottom: "2px",
            fontSize: "9px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {data.title || "Row Title"}
        </div>
        <div
          style={{
            color: "#6c757d",
            fontSize: "8px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontStyle: "italic",
          }}
        >
          {data.description || "No description"}
        </div>
      </div>

      {/* Right Handle (Output) */}
      <Handle
        type="source"
        position={Position.Right}
        id={id + "-output"}
        onConnect={(params) => {
          console.log("=== Row Handle Connect ===", {
            handleId: id + "-output",
            rowTitle: data.title,
            rowId: id,
            connectionParams: params,
            sourceNode: id,
            targetNode: params.target,
          });
        }}
        style={{
          background: isConnected
            ? "#28a745"
            : selected
            ? "#1976d2"
            : "#6c757d",
          width: "8px",
          height: "8px",
          right: "-4px",
          top: "50%",
          transform: "translateY(-50%)",
          border: "2px solid white",
          opacity: isConnected ? 0.7 : 1,
          cursor: isConnected ? "not-allowed" : "crosshair",
          zIndex: 1000,
        }}
      />
    </div>
  );
};
